import React, { useState, useRef } from 'react';
import { Card, CardBody, CardTitle, Form, FormGroup, Label, Input, Button } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import seoApi from 'Api/seoApi';
import { Toast } from "primereact/toast"
import CustomBreadCrumb from 'utils/CustomBreadCrumb/CustomBreadCrumb';

const AddSeo = () => {
    const toast = useRef(null);
    const navigate = useNavigate()
    const [seo, setSeo] = useState({
        pageName: '',
        title: '',
        description: '',
        keywords: '',
        schema: ''
    })

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === 'schema') {
            try {
                // Try to parse and re-stringify to format JSON
                const parsedJSON = JSON.parse(value);
                setSeo({
                    ...seo,
                    [name]: JSON.stringify(parsedJSON, null, 2)
                });
            } catch (error) {
                // If invalid JSON, just set the raw value
                setSeo({ ...seo, [name]: value });
            }
        } else {
            setSeo({ ...seo, [name]: value });
        }
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        try {
            // Validate and parse schema
            const parsedSchema = JSON.parse(seo.schema);
            
            // Prepare data with parsed schema
            const seoData = {
                ...seo,
                schema: parsedSchema
            };
            
            const response = await seoApi.addSeo(seoData)
            console.log('API Response:', response);
            
            if (response && response.data && response.data.success) {
                toast.current.show({ severity: 'success', summary: 'Success', detail: response.data.message || 'SEO added successfully' });
                setTimeout(() => {
                    navigate('/seo');
                }, 1000);
            } else {
                toast.current.show({ 
                    severity: 'error', 
                    summary: 'Error', 
                    detail: (response.data && response.data.message) || 'Failed to add SEO' 
                });
            }
        } catch (error) {
            if (error instanceof SyntaxError) {
                toast.current.show({ severity: 'error', summary: 'Error', detail: 'Invalid JSON schema format' });
            } else {
                console.error('Error details:', error);
                toast.current.show({ 
                    severity: 'error', 
                    summary: 'Error', 
                    detail: error.response?.data?.message || 'Failed to add SEO' 
                });
            }
        }
    }

    const breadcrumbItems = [
        { label: "Pixwik", link: "/" },
        { label: "SEO", link: "/seo" },
        { label: "Add SEO", link: "#" },
    ]

    return (
        <div>
            <Toast ref={toast} />
            <CustomBreadCrumb data={breadcrumbItems} pageTitle="Add SEO" />
            <Card className="mt-4">
                <CardBody>
                    <CardTitle className="mb-4">Add SEO</CardTitle>
                    <Form onSubmit={handleSubmit}>
                        <FormGroup>
                            <Label>Page Name</Label>
                            <Input 
                                type="text" 
                                name="pageName" 
                                value={seo.pageName} 
                                onChange={handleChange}
                                required 
                                placeholder="Enter page name (e.g. /institution)"
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label>Title</Label>
                            <Input 
                                type="text" 
                                name="title" 
                                value={seo.title} 
                                onChange={handleChange}
                                required
                                placeholder="Enter title (e.g. Institution Data)"
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label>Description</Label>
                            <Input 
                                type="textarea" 
                                name="description" 
                                value={seo.description} 
                                onChange={handleChange}
                                required
                                rows="3"
                                placeholder="Enter SEO description"
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label>Keywords</Label>
                            <Input 
                                type="textarea" 
                                name="keywords" 
                                value={seo.keywords} 
                                onChange={handleChange}
                                required
                                rows="2"
                                placeholder="Enter keywords (comma separated e.g. seo,test,example)"
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label>Schema</Label>
                            <Input 
                                type="textarea" 
                                name="schema" 
                                value={seo.schema} 
                                onChange={handleChange}
                                required
                                rows="20"
                                style={{ 
                                    fontFamily: 'monospace',
                                    fontSize: '14px',
                                    whiteSpace: 'pre',
                                    overflowX: 'auto',
                                }}
                            />
                        </FormGroup>
                        <div className="d-flex justify-content-end mt-4">
                            <Button type="button" color="secondary" className="me-2" onClick={() => navigate('/seo')}>
                                Cancel
                            </Button>
                            <Button type="submit" color="primary">
                                Submit
                            </Button>
                        </div>
                    </Form>
                </CardBody>
            </Card>
        </div>
    )
}

export default AddSeo